import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import purchaseSimSagas from './inventory/purchaseSim/saga';
import genericSagas from './generic/saga';
import reportsSagas from './reports/saga';
import inventoryTransferSagas from './inventory/inventoryTransfer/saga';
import dealersSagas from './dealer/saga';
import activationSagas from './activation/saga'


export default function* rootSaga() {
        yield all([
                authSagas(),
                purchaseSimSagas(),
                genericSagas(),
                reportsSagas(),
                inventoryTransferSagas(),
                dealersSagas(),
                activationSagas()

        ])
}